module.exports = __webpack_public_path__ + "img/loader01.cdae69e2.gif";